import React from 'react';

const SellTicketsHeader = ({ title, subtitle }) => (
    <div className='sell-tickets__header'>
        <h2 className="sell-tickets__header__1 h3">
            <span className='sell-tickets-header__title'>{title}</span>
        </h2>
        <p className='sell-tickets-header__subtitle d-block'>{subtitle}</p>
    </div>
);

export default SellTicketsHeader;
